import React from 'react';

import {
  Card,
  CardContent,
  Popover,
  Stack,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@gogame/components';

import TextViewer from './TextViewer';

const SmartTooltip = ({
  anchor,
  name,
  formula,
  hint,
  showGlossary,
  glossaryItems,
  anchorOrigin,
  transformOrigin,
  hoverDelay,
}) => {
  return (
    <Popover
      hover={true}
      hoverDelay={hoverDelay}
      anchor={anchor}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      elevation={8}
    >
      <Card elevation={6}>
        <CardContent>
          <Stack spacing={2} maxWidth={528}>
            <Stack spacing={0.5}>
              <Typography variant={'body1'}>
                <b>{name}</b>
              </Typography>
              {formula ? (
                <Typography variant={'caption'}>{formula}</Typography>
              ) : null}
              {hint ? (
                <Typography variant={'caption'} color={'textSecondary'}>
                  <TextViewer text={hint} />
                </Typography>
              ) : null}
            </Stack>
            {showGlossary && glossaryItems?.length ? (
              <Table>
                <TableBody>
                  {glossaryItems.map(({ term, definition }, i) => (
                    <TableRow key={i}>
                      <TableCell disableGutters={true}>{term}</TableCell>
                      <TableCell disableGutters={true}>
                        <TextViewer text={definition} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : null}
          </Stack>
        </CardContent>
      </Card>
    </Popover>
  );
};

export default SmartTooltip;
